/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react'
import { IconButton, Tooltip } from '@radix-ui/themes'
import toast from 'react-hot-toast'
import { CopyIcon } from '@radix-ui/react-icons'
import { IconInfoCircle } from '@tabler/icons-react'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'

interface InfoItemProps {
  icon: React.ReactNode
  title: string
  value: any
  showCopyButton?: boolean
}

const InfoItem: React.FC<InfoItemProps> = ({ icon, title, value, showCopyButton }) => {
  const copyToClipboard = (value: string) => {
    navigator.clipboard.writeText(value)
    toast.success('Copied to clipboard', DEFAULT_TOAST_CONFIG)
  }

  return (
    <div className="flex justify-between items-center mt-4">
      <div className="flex items-center text-sm text-neutral-11 dark:text-neutral-9">
        {icon}
        <span className="ml-2 font-medium">{title}</span>
      </div>
      <div className="flex">
        <Tooltip content={value}>
          <span
            className={`text-sm font-medium truncate max-w-[150px] text-right ${value === 'Unknown' ? 'text-neutral-11' : 'text-mainText'}`}
          >
            {value}
          </span>
        </Tooltip>

        {value === 'Unknown' && (
          <Tooltip
            content={`Open the iVerify App on this device to fetch more data.`}
            side="top"
            align="end"
            className="max-w-[400px]"
          >
            <IconInfoCircle size={18} className="text-secondaryText mt-[1px] ml-2 cursor-pointer" />
          </Tooltip>
        )}

        {showCopyButton && (
          <IconButton
            size="1"
            aria-label="Copy value"
            color="gray"
            variant="ghost"
            onClick={() => copyToClipboard(value)}
            className="ml-1 -mt-[1px] dark:text-neutral-4 hover:dark:bg-inputBackground focus:dark:bg-inputBackground"
            
          >
            <CopyIcon />
          </IconButton>
        )}
      </div>
    </div>
  )
}

export default InfoItem
